import { computed } from 'vue'

/** 交易进程弹窗 mask：与 tradeReviewModal 一致，宽度由 process-sheet 自身控制 */
export function useProcessSheetMask(isMobileLayout) {
  const sheetPos = computed(() => (isMobileLayout.value ? 'sheetBottom' : 'centerProcess'))

  const maskContentStyle = computed(() => {
    const base = {
      padding: '0',
      background: 'transparent',
      border: 'none',
      boxShadow: 'none',
      overflow: 'visible',
      width: 'var(--hs-process-sheet-w, min(420px, calc(100vw - 32px)))',
      maxWidth: 'calc(100vw - 32px)',
      boxSizing: 'border-box',
    }
    if (isMobileLayout.value) {
      return {
        ...base,
        width: '100%',
        maxWidth: '100%',
        maxHeight: 'min(90vh, 720px)',
      }
    }
    return { ...base, maxHeight: 'min(560px, calc(100vh - 120px))' }
  })

  return { sheetPos, maskContentStyle }
}
